export const darkTheme = {
  'font-feature-settings': '"zero", "cv09", "cv10"',
  '--font-name': 'Inter var',
  'font-family': "'Inter var', sans-serif",
  '--primary': '247 251 255',
  '--primary-shade-50': '238 241 246',
  '--primary-shade-100': '224 230 240',
  '--primary-shade-200': '191 203 223',
  '--primary-shade-300': '160 178 207',
  '--primary-shade-400': '148 163 184',
  '--primary-shade-500': '100 116 139',
  '--primary-shade-600': '73 101 146',
  '--primary-shade-700': '58 80 115',
  '--primary-shade-800': '44 61 88',
  '--primary-shade-900': '30 41 59',
  '--primary-shade-950': '30 41 59',
  '--secondary': '255 66 0',
  '--secondary-shade-50': '255 236 229',
  '--secondary-shade-100': '255 218 204',
  '--secondary-shade-200': '255 184 158',
  '--secondary-shade-300': '255 150 112',
  '--secondary-shade-400': '255 113 61',
  '--secondary-shade-500': '255 66 0',
  '--secondary-shade-600': '219 58 0',
  '--secondary-shade-700': '173 46 0',
  '--secondary-shade-800': '133 35 0',
  '--secondary-shade-900': '102 27 0',
  '--secondary-shade-950': '61 16 0',
  '--primaryText': '15 23 42',
  '--primaryText-shade-50': '238 241 246',
  '--primaryText-shade-100': '224 230 240',
  '--primaryText-shade-200': '191 203 223',
  '--primaryText-shade-300': '160 178 207',
  '--primaryText-shade-400': '148 163 184',
  '--primaryText-shade-500': '100 116 139',
  '--primaryText-shade-600': '73 101 146',
  '--primaryText-shade-700': '58 80 115',
  '--primaryText-shade-800': '44 61 88',
  '--primaryText-shade-900': '30 41 59',
  '--primaryText-shade-950': '21 28 41',
  '--secondaryText': '255 255 255',
  '--secondaryText-shade-50': '255 236 229',
  '--secondaryText-shade-100': '255 218 204',
  '--secondaryText-shade-200': '255 184 158',
  '--secondaryText-shade-300': '255 150 112',
  '--secondaryText-shade-400': '255 113 61',
  '--secondaryText-shade-500': '255 66 0',
  '--secondaryText-shade-600': '219 58 0',
  '--secondaryText-shade-700': '173 46 0',
  '--secondaryText-shade-800': '133 35 0',
  '--secondaryText-shade-900': '102 27 0',
  '--secondaryText-shade-950': '61 16 0',
  '--theme-primary-color': 'rgb(247, 251, 255)',
  '--theme-secondary-color': 'rgb(255, 66, 0)',
  '--primary-text-color': 'rgb(15, 23, 42)',
  '--secondary-text-color': 'rgb(255, 255, 255)',
  '--primary-shade-default': '30 41 59',
  '--primaryText-shade-default': '224 230 240',
  '--primary-shade-0': '255 255 255',
  '--primaryText-shade-0': '255 255 255',
  '--primary-shade-1000': '5 9 23',
  '--primaryText-shade-1000': '9 12 17',
  '--secondary-shade-default': '255 66 0',
  '--secondaryText-shade-default': '255 218 204',
  '--secondary-shade-0': '255 255 255',
  '--secondaryText-shade-0': '255 255 255',
  '--secondary-shade-1000': '26 7 0',
  '--secondaryText-shade-1000': '26 7 0'
};

export const lightTheme = {
  'font-feature-settings': '"zero", "cv09", "cv10"',
  '--font-name': 'Inter var',
  'font-family': "'Inter var', sans-serif",
  '--primary': '247 251 255',
  '--primary-shade-50': '12 16 24',
  '--primary-shade-100': '30 41 59',
  '--primary-shade-200': '38 52 75',
  '--primary-shade-300': '51 71 102',
  '--primary-shade-400': '148 163 184',
  '--primary-shade-500': '100 116 139',
  '--primary-shade-600': '119 145 187',
  '--primary-shade-700': '153 173 204',
  '--primary-shade-800': '187 200 221',
  '--primary-shade-900': '221 228 238',
  '--primary-shade-950': '241 245 249',
  '--secondary': '255 66 0',
  '--secondary-shade-50': '255 236 229',
  '--secondary-shade-100': '255 218 204',
  '--secondary-shade-200': '255 184 158',
  '--secondary-shade-300': '255 150 112',
  '--secondary-shade-400': '255 113 61',
  '--secondary-shade-500': '255 66 0',
  '--secondary-shade-600': '219 58 0',
  '--secondary-shade-700': '173 46 0',
  '--secondary-shade-800': '133 35 0',
  '--secondary-shade-900': '102 27 0',
  '--secondary-shade-950': '61 16 0',
  '--primaryText': '15 23 42',
  '--primaryText-shade-50': '12 16 24',
  '--primaryText-shade-100': '30 41 59',
  '--primaryText-shade-200': '38 52 75',
  '--primaryText-shade-300': '51 71 102',
  '--primaryText-shade-400': '148 163 184',
  '--primaryText-shade-500': '100 116 139',
  '--primaryText-shade-600': '119 145 187',
  '--primaryText-shade-700': '153 173 204',
  '--primaryText-shade-800': '187 200 221',
  '--primaryText-shade-900': '221 228 238',
  '--primaryText-shade-950': '238 241 246',
  '--secondaryText': '255 255 255',
  '--secondaryText-shade-50': '255 236 229',
  '--secondaryText-shade-100': '255 218 204',
  '--secondaryText-shade-200': '255 184 158',
  '--secondaryText-shade-300': '255 150 112',
  '--secondaryText-shade-400': '255 113 61',
  '--secondaryText-shade-500': '255 66 0',
  '--secondaryText-shade-600': '219 58 0',
  '--secondaryText-shade-700': '173 46 0',
  '--secondaryText-shade-800': '133 35 0',
  '--secondaryText-shade-900': '102 27 0',
  '--secondaryText-shade-950': '61 16 0',
  '--theme-primary-color': 'rgb(247, 251, 255)',
  '--theme-secondary-color': 'rgb(255, 66, 0)',
  '--primary-text-color': 'rgb(15, 23, 42)',
  '--secondary-text-color': 'rgb(255, 255, 255)',
  '--primary-shade-default': '30 41 59',
  '--primaryText-shade-default': '30 41 59',
  '--primary-shade-0': '0 0 0',
  '--primaryText-shade-0': '0 0 0',
  '--primary-shade-1000': '255 255 255',
  '--primaryText-shade-1000': '255 255 255',
  '--secondary-shade-default': '255 66 0',
  '--secondaryText-shade-default': '255 218 204',
  '--secondary-shade-0': '255 255 255',
  '--secondaryText-shade-0': '255 255 255',
  '--secondary-shade-1000': '26 7 0',
  '--secondaryText-shade-1000': '26 7 0'
};
